import { createSlice } from "@reduxjs/toolkit";
import { ReducerRegistry } from "@neumetric/blueprint-lib/store";

const initialState = {
  auditList: null,
  currentAudit: null,
  currentAuditDetails: null,
  currentControl: null,
  reportFormats: [],
  blueprintModels: [],
  auditTypes: [],
  governors: [],
  users: [],
  createAuditSuccess: false,
  createReportSuccess: false,
  reportList: null,
  subscribedBlueprintList: [],
  reportFrameworkList: [],
  modelDetails: null,
  reportDetails: null,
  auditUploadHistory: null,
  disableAction: false,
  reportBlueprints: null,
};

const auditSlice = createSlice({
  name: "audit",
  initialState: initialState,
  reducers: {
    fetchAuditlist: () => {},
    fetchAudit: () => {},
    fetchControl: () => {},
    fetchControlResult: () => {},
    fetchReportFormats: () => {},
    fetchReportBlueprints: () => {},
    fetchBlueprintModels: () => {},
    fetchAuditTypes: () => {},
    fetchGovernors: () => {},
    fetchUsers: () => {},
    addControlComment: () => {},
    updateControlResult: () => {},
    updateIncludeReport: () => {},
    selectEvidence: () => {},
    deleteEvidence: () => {},
    updateControlResponse: () => {},
    exportToCSV: () => {},
    downloadTemplate: () => {},
    uploadAudit: () => {},
    createAudit: () => {},
    updateAudit: () => {},
    submitAudit: () => {},
    createReport: (state) => {
      state.createReportSuccess = false;
    },
    createReportSuccess: (state) => {
      state.createReportSuccess = true;
    },
    fetchReportList: () => {},
    fetchReportShow: () => {},
    fetchSubscribedBlueprints: () => {},
    fetchModelDetails: () => {},
    fetchReportFrameworkList: () => {},
    fetchAuditDetails: () => {},
    fetchAuditUploadHistory: () => {},
    downloadUploadHistory: () => {},
    shareAuditReport: () => {},
    updateAuditStatus: () => {},
    createAuditReport: () => {},
    updateAuditReport: () => {},
    generateSoc2Type2Report: () => {},
    setReportFrameworkList: (state, action) => {
      state.reportFrameworkList = action.payload;
    },
    setModelDetails: (state, action) => {
      state.modelDetails = action.payload;
    },
    setSubscribedBlueprintList: (state, action) => {
      state.subscribedBlueprintList = action.payload;
    },
    setReportList: (state, action) => {
      state.reportList = action.payload;
    },
    setAuditList: (state, action) => {
      state.auditList = action.payload;
    },
    setCurrentAudit: (state, action) => {
      state.currentAudit = action.payload;
    },
    setCurrentAuditDetails: (state, action) => {
      state.currentAuditDetails = action.payload;
    },
    resetCurrentAuditDetails: (state) => {
      state.currentAuditDetails = null;
    },
    setCurrentControl: (state, action) => {
      state.currentControl = action.payload;
    },
    setReportFormats: (state, action) => {
      state.reportFormats = action.payload;
    },
    setBlueprintModels: (state, action) => {
      state.blueprintModels = action.payload;
    },
    setAuditTypes: (state, action) => {
      state.auditTypes = action.payload;
    },
    setGovernors: (state, action) => {
      state.governors = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setCurrentReportDetails: (state, action) => {
      state.reportDetails = action.payload;
    },
    updateCurrentAudit: (state, action) => {
      state.currentAudit = { ...state.currentAudit, ...(action.payload || {}) };
    },
    updateCurrentControl: (state, action) => {
      state.currentControl = {
        ...state.currentControl,
        ...(action.payload || {}),
      };
    },
    setAuditUploadHistory: (state, action) => {
      state.auditUploadHistory = action.payload;
    },
    setActionDisable: (state, action) => {
      state.disableAction = action.payload;
    },
    setReportBlueprints: (state, action) => {
      state.reportBlueprints = action.payload;
    },
  },
});

export const auditActions = auditSlice.actions;

ReducerRegistry.register("audit", auditSlice.reducer);
